import React from "react"

import { Translator } from "./Translator"

export const defaultTranslator = new Translator()

export const TranslatorContext = React.createContext<Translator>(defaultTranslator)

TranslatorContext.displayName = "TranslatorContext"
